import { lazy, ReactNode } from 'react';
import { useOnboardingContext } from '../../../../features/digital-onboarding/layout/onboarding.context';

const CurrencyPage = lazy(() => import('./currency/page'));
const BusinessRequestPage = lazy(() => import('./business-request/page'));
const PrintFormsPage = lazy(() => import('./print-forms/page'));

const ExistingCustomerPage = () => {
  const { state } = useOnboardingContext();

  const component: Record<typeof state.active, ReactNode> = {
    currency: <CurrencyPage />,
    'business-request': <BusinessRequestPage />,
    'print-forms': <PrintFormsPage />,
  };

  return <>{component[state.active]}</>;
};

export default ExistingCustomerPage;
